import { Swords } from "lucide-react";
import { ModelSources } from "./ModelSources";

export const DebatePanel = ({ turn }) => {
  const models = Object.keys(turn.debate || {});
  if (!models.length) return null;
  return (
    <div data-testid="debate-panel" className="mt-6">
      <div className="flex items-center gap-2 mb-2">
        <Swords size={13} className="text-[#F87171]" />
        <p className="text-[11px] uppercase tracking-[0.18em] text-slate-400 font-mono">Debate round</p>
      </div>
      <p data-testid="debate-intro" className="text-sm text-slate-500 mb-3">
        The AIs disagreed{turn.agreement ? ` (${turn.agreement.score}% agreement)` : ""}, so each one challenged the others before the final answer.
      </p>
      <ModelSources answers={turn.debate} statuses={turn.debateStatuses} models={models} prefix="debate" testid="debate-accordion" />
    </div>
  );
};
